import React from 'react';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { useModal } from 'context/modal';
import Icon from 'components/Icon';
import { useInfo } from 'hooks/query/useJob';
import queryKeys from 'config/queryKeys';

const InsuranceValuation = () => {
  const { id } = useParams();
  const { modalNames, open } = useModal();
  const queryClient = useQueryClient();

  const {
    data: { calc_info: calcInfo },
  } = useInfo(id);

  const openModal = () => {
    open(modalNames.insuranceValuation, {
      jobId: id,
      valuation: calcInfo?.shipment_valuation,
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.job, id]);
      },
    });
  };

  return (
    <React.Fragment>
      <div className="new-table--row bcg-light">
        <div className="new-table--row--item justify-content-center w40">
          <b>Insurance Valuation</b>
        </div>
        <div className="new-table--row--item w60 justify-content-center no-padding">
          <button className="btn p20 flex-grow-1 d-flex text-center no-margin" onClick={openModal}>
            <Icon icon="add" size={16} />
          </button>
        </div>
      </div>

      <React.Fragment>
        <div className="new-table--row">
          <div className="new-table--row--item justify-content-center w40" />
          <div className="new-table--row--item no-side-shadows w60 no-padding align-items-start">
            <div className="new-table--row with-shadow">
              <div className="new-table--row--item  justify-content-center no-side-shadows">
                <b>${calcInfo?.shipment_valuation}</b>
              </div>
              <div className="new-table--row--item  justify-content-center no-side-shadows">
                <b>${calcInfo?.shipment_valuation_total}</b>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </React.Fragment>
  );
};

export default InsuranceValuation;
